export const verify = {
  invalid_or_expired_token:
    "Invalid or expired token. Please request a new password reset.",
  title: "Activate Account",
  missing_link: "Activation link is missing or invalid.",
  go_to_login: "Go to Login",
  email: "Email",
  first_name: "First Name",
  last_name: "Last Name",
  nickname: "Nickname",
  new_password: "New Password",
  confirm_password: "Confirm Password",
  date_of_birth: "Date of Birth",
  gender: "Gender",
  gender_male: "Male",
  gender_female: "Female",
  gender_not_share: "Don't want to share",
  activate: "Activate",
  activating: "Activating...",
  activated: "Account activated. Now you can log in into the mobile app!",
  all_fields_required: "All required fields must be filled",
  passwords_do_not_match: "Passwords do not match",
  error: "Activation failed",
};
